<template>
  <div>
    <BaseAdvancedList
      ref="list"
      searchable
      without-query-string
      :loading="pending"
      :entities="subscriptions"
      :meta="meta"
      @page-change="handlePageChange"
      @search-change="handleSearchChange"
    >
      <template #header>
        <ListHeader />
      </template>

      <template #default="listProps">
        <ListItem :subscription="listProps.entity" />
      </template>
    </BaseAdvancedList>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations, mapState } from 'vuex';
import ListHeader from './ListHeader.vue';
import ListItem from './ListItem.vue';

export default {
  name: 'Subscriptions',
  components: {
    ListHeader,
    ListItem,
  },
  props: {
    contactListUuid: {
      type: String,
      required: true,
    },
  },
  data: () => ({
    pending: false,
  }),
  computed: {
    ...mapState('ui/contactListSubscriptions', ['meta', 'links']),
    ...mapGetters('ui/contactListSubscriptions', ['subscriptions']),
  },
  created() {
    this.init();
  },
  destroyed() {
    this.setIds([]);
    this.setMeta(null);
    this.setLinks(null);
  },
  methods: {
    ...mapActions('ui/contactListSubscriptions', {
      loadSubscriptions: 'load',
    }),

    ...mapMutations('ui/contactListSubscriptions', ['setIds', 'setMeta', 'setLinks']),

    async init(params = {}) {
      this.pending = true;

      try {
        const { contactListUuid } = this;

        await this.loadSubscriptions({ contactListUuid, params });
      } catch (error) {
        //
      }

      this.pending = false;
    },

    handlePageChange(page) {
      this.init({ filter: { search: this.$refs.list.search }, page });
    },

    handleSearchChange(search) {
      this.init({ filter: { search } });
    },
  },
};
</script>
